import { createContext } from 'react';

const MutationsContext = createContext();

export default MutationsContext;
